import { Http } from '@angular/http';
import { Injectable } from '@angular/core';
import { ProviderFilter, ProviderSummary, Provider, NewProvider, UpdatedProvider } from './provider.types';
import { PagedList } from '../common/common.types';

@Injectable()
export class ProviderService {
	private providerUrl = 'api/providers';

	constructor(private http: Http) { }

	getProviders(filter?: ProviderFilter): Promise<PagedList<ProviderSummary>> {
		return this.http.get(this.providerUrl, { params: filter })
			.toPromise()
			.then(response => response.json() as PagedList<ProviderSummary>);
	}

	getProvider(providerId: number): Promise<Provider> {
		return this.http.get(`${this.providerUrl}/${providerId}`)
			.toPromise()
			.then(response => response.json() as Provider);
	}

	createProvider(newProvider: NewProvider): Promise<number> {
		return this.http.post(this.providerUrl, newProvider)
			.toPromise()
			.then(response => response.json() as number);
	}

	updateProvider(providerId: number, updatedProvider: UpdatedProvider): Promise<any> {
		return this.http.put(`${this.providerUrl}/${providerId}`, updatedProvider)
			.toPromise();
	}
}
